import { module } from 'modujs';
import Swiper, { Lazy, Pagination, Navigation } from 'swiper';
import { lazyLoadImage, animDepixelate } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);

        this.$container = this.$('container')[0]
        this.$pagination = this.$('pagination')[0]
        this.$nextBtn = this.$('next')[0]

        console.log(this);
    }

    init() {
        this.swiper = new Swiper(this.$container, {
            modules: [Lazy, Pagination, Navigation],
            loop: true,
            loopAdditionalSlides: 1,
            preloadImages: false,
            grabCursor: true,
            lazy: {
                checkInView: true,
                loadPrevNext: true
            },
            pagination: {
                el: this.$pagination,
                type: 'custom',
                renderCustom(swiper, current, total) {
                    return `${current.toString().padStart(2,'0')} / ${total.toString().padStart(2,'0')}`
                }
            },
            navigation: {
                nextEl: this.$nextBtn
            },
            on: {
                init(swiper) {
                    if(swiper.lazy && swiper.lazy.enabled !== false) {
                        for(let slide of swiper.slides) {
                            slide.classList.add('-pixelated')
                        }
                    }
                },
                lazyImageReady(swiper, slideEl, imageEl) {
                    animDepixelate(imageEl)
                    slideEl.classList.remove('-pixelated');
                },
                slideChange(swiper) {
                    const activeSlide = swiper.slides[swiper.activeIndex]
                    const slideIndex = activeSlide.getAttribute('data-swiper-slide-index')

                    for(let slide of swiper.slides.filter(item => item.getAttribute('data-swiper-slide-index') == slideIndex)) {
                        const video = slide.querySelector('video')
                        video?.play()
                    }
                },
                click(swiper, event) {
                    if(swiper.clickedSlide.classList.contains('swiper-slide-next')) {
                        swiper.slideNext()
                    }
                }
            },
        });
    }

    inview(e) {
        if(e.target == this.el) {
            this.swiper.lazy.load()
        }
    }
}
